const updateQuantityButtonStates = (selector) => {
  if (!selector) return;

  const qtyInput = selector.querySelector('[data-quantity-input]');
  const incBtn = selector.querySelector('[data-quantity-inc]');
  const decBtn = selector.querySelector('[data-quantity-dec]');
  if (!qtyInput) return;

  const max = qtyInput.max ? +qtyInput.max : Infinity;
  const value = +qtyInput.value;

  if (incBtn) incBtn.disabled = value >= max;
  if (decBtn) decBtn.disabled = value <= 1;
};

export default updateQuantityButtonStates;
